import React from 'react';
import { Row, Col, Button, Image } from 'bootstrap';
import classnames from 'classnames';
import IntercomActions from 'flux/actions/IntercomActions';

/**
 * Upgrade Alert
 *
 * Used to alert the user if they do not have access to the product (show,
 * schedule, lists, & docs) that they are tyring to access.
 */
export default React.createClass({
  displayName: 'UpgradeAlert',

  propTypes: {
    display: React.PropTypes.bool,
    title: React.PropTypes.string,
    type: React.PropTypes.string,
    desc: React.PropTypes.string,
    assetLink: React.PropTypes.string,
    learnMoreLink: React.PropTypes.string,
    upgradeLink: React.PropTypes.string,
    classes: React.PropTypes.string,
  },

  render() {
    let {
      children,
      display,
      title,
      desc,
      assetLink,
      learnMoreLink,
      // upgradeLink,
      classes,
    } = this.props;

    return !display && children ? (
      <div>{children}</div>
    ) : (
      <Col className={classnames('upgrade-alert', classes)} md={24}>
        <Row>
          <Col className="upgrade-alert-title" md={24}>
            <h2>{title}</h2>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col className="upgrade-alert-desc" md={24}>
            <p>{desc}</p>
          </Col>
        </Row>
        <Row className="upgrade-alert-btn-wrapper">
          <Col mdOffset={7} md={5} smOffset={4} sm={8} xs={24}>
            <a
              href={learnMoreLink}
              target="_blank"
              className="upgrade-alert-learn-more-btn"
            >
              Learn More
            </a>
          </Col>
          <Col md={5} sm={8} xs={24}>
            <Button
              onClick={this._handleUpgradeClick}
              className="upgrade-alert-upgrade-btn"
            >
              Upgrade
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className="upgrade-alert-asset" md={24}>
            <Image responsive src={assetLink} />
          </Col>
        </Row>
      </Col>
    );
  },

  _handleUpgradeClick(e) {
    e.stopPropagation();

    let { type } = this.props;

    IntercomActions.productUpgrade(type);
  },
});
